/** @format */
import React, { FunctionComponent } from 'react';

import {
    OutOfStockNotification as BaseOutOfStockNotification,
    OutOfStockNotificationProps,
} from '@toucan/client/blocks/components/base-summary-item';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'basket-item__offline-product';

export const OutOfStockNotification: FunctionComponent<
    OutOfStockNotificationProps
> = (props) => {
    return (
        <BaseOutOfStockNotification data-testid={DEFAULT_TEST_ID} {...props} />
    );
};
